//3rd Party Components
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const CASASpinner = ({ message }) => {

    return (
        <Fragment>
            <Spinner message={message} />
        </Fragment>
    )
    
}

CASASpinner.propTypes = {
    message: PropTypes.string
};

export const Spinner = ({ message }) => {

    return (
        <div id="loadingPage" className={message ? 'guideLoading guideMessage' : 'guideLoading'}>
            {message ? <h1>{message}</h1> : ''}
        </div>
    );

};

Spinner.propTypes = {
    message: PropTypes.string
};


export default CASASpinner;